/**
 * Lazy Load Video
 * 
 * NOTE: polyfill in /lib/Settings.php
 * 
 * We iterate through all of the child <source> elements 
 * and flip their data-src attributes to src attributes. 
 * Then we need to trigger loading of the video by calling the element's load method, 
 * after which the media will begin playing automatically per the autoplay attribute.
 * https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/#for_video_acting_as_an_animated_gif_replacement
 */

export default () => {
  let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"))

  if (! lazyVideos) return

  let lazyVideoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let video = entry.target

        for (let source in video.children) {
          let videoSource = video.children[source]
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE" && videoSource.dataset.src) {
            videoSource.src = videoSource.dataset.src
          }
        }
        
        video.load()
        video.classList.add("loaded")
        lazyVideoObserver.unobserve(video)
      }
    })
  })

  lazyVideos.forEach(lazyVideo => {
    lazyVideoObserver.observe(lazyVideo)
  })

}


// WEBPACK FOOTER //
// ./src/js/modules/LazyLoadVideo.js